import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  overflow-x: auto;
  padding: 20px 0;

  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
    width: 100%;
  }

  h2 {
    color: #000;
    font-size: 18px;
    width: 100%;
    text-align: left;
    margin: 10px 0;
    font-weight: bold;
  }

  h3 {
    color: #888;
    font-size: 15px;
    width: 100%;
    text-align: left;
    margin: 0 0 5px 0;
    font-weight: bold;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .input {
    max-width: 390px;
    margin-bottom: 5px;
  }
`;
